import meetingThumb from "../../assets/images/meeting-thumb.png";
import ToggleButton from "../ToggleButton";

export const EndLiveWorkspace = ({ conferenceEndMeeting, endMeetingHandler, closeModalHandler }) => (
  <div className="modal">
    <div className="modal-content">
      <img src={meetingThumb} width={370} height={202} className="br-556" alt="" />
      <div className="flex-col m-tb-32 w-370">
        {!conferenceEndMeeting ? (
          <>
            <div className="flex m-b-16">
              <ToggleButton />
              <div className="flex-col p-l-8">
                <span className="B1-Medium m-b-8 h-24">Save meeting metadata</span>
                <span className="B3-Regular">Useful for converting meeting into a course.</span>
              </div>
            </div>
            <div className="flex">
              <ToggleButton />
              <div className="flex-col p-l-8">
                <span className="B1-Medium m-b-8 h-24">Share recorded meeting with participants</span>
                <span className="B3-Regular">Allows participants to rewatch the recorded meeting.</span>
              </div>
            </div>
          </>
        ) : (
          <div className="h-112 flex-col justify-content-center align-items-center">
            <div className="B1-Medium m-b-5"> Please wait.</div>
            <div className="B3-Regular"> The meeting is saving!</div>
            <div className="w-240 m-t-20">
              <div className="line-progress-bar">
                <span className="line-loading" />
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="space-between">
        <div className={`button button-lg button-bk button-r w-169 ${conferenceEndMeeting && "disable"}`} onClick={endMeetingHandler}>
          End Meeting
        </div>
        <div className="button button-lg button-r w-169" onClick={closeModalHandler}>
          Cancel
        </div>
      </div>
    </div>
  </div>
);
